import { AppMenuSavedDashboardInterface } from 'src/types/AppMenuInterface'

/**
 * Sort dashboards by name
 */
export const sortDashboardsFn = (dashboards: AppMenuSavedDashboardInterface[]) => {
  return dashboards.sort((a, b) =>
    Intl.Collator('en', { sensitivity: 'base' }).compare(a.name, b.name),
  )
}
